/* Copyright (c) 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useState } from "react";
import { Row, Col } from "react-awesome-styled-grid";
import { If, Then } from "react-if";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Flex, Text, theme, Table, Spacer } from "@nordcloud/gnui";
import {
  AdditionalInfo,
  CollapseItem,
} from "~/components/CollapseItem/CollapseItem";
import FlexContainer from "~/components/Styled/FlexContainer";
import { ServiceCommitment } from "~/models";
import { ACTIONS, Can, ROUTES } from "~/routing";
import { Popover } from "../Popover/Popover";
import { PopoverButton } from "../Popover/PopoverButton";
import { AddNewVersionServiceGroup } from "./AddNewVersionServiceGroup";
import { ServiceGroupItemProps } from "./types";

export const TagWrap = styled.div`
  transform: translateY(0.7rem);
`;

export function ServiceGroupItem({
  serviceGroup,
  refetch,
}: ServiceGroupItemProps) {
  const [isPopover, setIsPopover] = useState(false);

  return (
    <CollapseItem
      name={
        <FlexContainer grow>
          <div>
            <Text
              size="lg"
              weight="medium"
              tag="div"
              mb={theme.spacing.spacing01}
              ml={theme.spacing.spacing04}
            >
              {serviceGroup?.name}
            </Text>
            <Flex>
              <Text size="sm" tag="span" ml={theme.spacing.spacing04}>
                {serviceGroup.services?.length || 0} service
                {serviceGroup.services.length > 1 && "s"}
              </Text>
            </Flex>
          </div>
        </FlexContainer>
      }
      buttons={
        <FlexContainer>
          <If condition={serviceGroup.version}>
            <Then>
              <AdditionalInfo css={{ marginLeft: "auto", width: "initial" }}>
                <Text size="sm" weight="regular" tag="div">
                  <Text
                    size="sm"
                    weight="regular"
                    color={theme.color.text.text02}
                    tag="span"
                  >
                    Version:
                  </Text>
                  <br /> {serviceGroup.version}
                </Text>
              </AdditionalInfo>
            </Then>
          </If>
          <Can action={ACTIONS.ADD_SERVICE_GROUP_SLA}>
            <Popover
              alignRight
              trigger={<PopoverButton />}
              isPopover={isPopover}
              setIsPopover={setIsPopover}
            >
              <AddNewVersionServiceGroup
                serviceGroup={serviceGroup}
                refetch={refetch}
              />
            </Popover>
          </Can>
        </FlexContainer>
      }
    >
      <Row>
        <Col>
          <Spacer height="1rem" />
          <Table tiny>
            <Table.thead>
              <Table.tr>
                <Table.th css={{ width: "90%" }}>Services</Table.th>
                <Table.th>Version</Table.th>
              </Table.tr>
            </Table.thead>
            <Table.tbody>
              {serviceGroup?.services?.map((service: ServiceCommitment) => {
                return (
                  <Table.tr key={service?.id}>
                    <Table.td>
                      <Link
                        to={`${ROUTES.serviceCommitments.index}/${service.id}`}
                      >
                        {service?.name}
                      </Link>
                    </Table.td>
                    <Table.td>{service?.version}</Table.td>
                  </Table.tr>
                );
              })}
            </Table.tbody>
          </Table>
        </Col>
      </Row>
    </CollapseItem>
  );
}
